import * as ClickTracker from "@omni/services/tracking/trackers/click/click.tracker";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { TrackingEvent } from "@omni/types/components/tracking/trackingEvent.type";
import { TrackingProps } from "@omni/types/components/tracking/trackingProps.type";
import { isDefined } from "@omni/utils/helper.utils";
import { MouseEvent, useMemo } from "react";

import { toTrackingEvents } from "./helpers/trackingEvent.helpers";

const toCallback = (event: TrackingEvent) => {
    if (!isDefined(event)) return;
    if (!isDefined(event.trackingInfo)) return;

    switch (event.type) {
        case EventType.BannerClick:
        case EventType.BannerSlideClick:
        case EventType.ButtonClick:
        case EventType.NavigationClick:
        case EventType.LinkClick: {
            const trackingInfo = event.trackingInfo;

            return (element: HTMLElement) => {
                ClickTracker.trackElement(event.type, trackingInfo, element);
            };
        }
    }
};

export const useClickTracking = (trackingProps: TrackingProps | undefined) => {
    const trackingEvents = useMemo(() => {
        return toTrackingEvents(trackingProps ?? {});
    }, [trackingProps]);

    const trackClick = useMemo(() => {
        return trackingEvents.map(toCallback).filter(isDefined).at(0);
    }, [trackingEvents]);

    const onClick = (event: MouseEvent<HTMLElement>) => {
        trackClick?.(event.currentTarget);
    };

    return { onClick };
};
